import axiosInstance from '../../../../services/axios/axios';
import { WrapImsPacket } from '../../../../store/utility';
// import { ReactElement } from 'react';

/**
 * Get list of work queue results for the user
 *
 */
export const fetchWorkQueueAdmins = async workQueueArgs => {
	try {
		const response = await axiosInstance.get(
			`api/WorkQueue/GetWorkQueueAdmins`,
			{
				params: {
					...workQueueArgs,
				},
			}
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch work queue admins: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Add or Remove Work Queue Admins
 *
 */
export const AddOrRemoveWorkQueueAdmins = async workQueueArgs => {
	try {
		const response = await axiosInstance.post(
			`api/WorkQueue/AddOrRemoveWorkQueueAdmins`,
			WrapImsPacket(workQueueArgs)
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch work queue admins: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Assign or Re-Assign work queue requests****
 * number systemID
 * string currentUser_ESO_ID
 * string assignee_FI_ID
 * List of {Name, ID} requests
 * where Name = trackingNumber and ID = work queue row key
 */
export const AssignWorkQueueRequests = async workQueueArgs => {
	try {
		const response = await axiosInstance.post(
			`api/WorkQueue/AssignWorkQueueRequests`,
			WrapImsPacket(workQueueArgs.requests),
			{
				params: {
					systemID: workQueueArgs.systemID,
					assignee_FI_ID: workQueueArgs.assignee_FI_ID,
					currentUser_ESO_ID: workQueueArgs.currentUser_ESO_ID,
				},
			}
		);

		return response;
	} catch (ex) {
		console.error('Unable to reassign requests: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Search for Person
 *
 */
export const fetchPersonSearch = async payload => {
	try {
		const response = await axiosInstance.post(
			`api/Components/PersonSearch`,
			payload
		);
		return response;
	} catch (ex) {
		console.error('Unable to fetch person search: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Get list of work queue system list for the user
 *
 */
export const fetchWorkQueueSystemList = async workQueueArgs => {
	try {
		const response = await axiosInstance.get(
			`api/WorkQueue/GetAssignedWorkQueueList`,
			{
				params: {
					...workQueueArgs,
				},
			}
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch work queue system results: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};
